<template>
  <div>
    <notifications group="rules" position="top center" />
    <span>
      {{ rawIps }}
      <button
        v-if="rawIps"
        @click.prevent="openEditIPModal"
        class="btn p-0 ml-3"
      >
        <i class="flaticon-edit text-primary"></i></button
    ></span>
    <modal
      :name="'editIPModal' + rowData.id"
      :width="500"
      height="auto"
      @closed="clearData"
    >
      <div class="container pt-10 vld-parent pb-5">
        <loading
          :active.sync="editLoading"
          :can-cancel="false"
          color="#5739B2"
          :z-index="9"
          :is-full-page="fullPage"
        ></loading>
        <h2 class="text-center">Edit IP</h2>
        <b-badge variant="warning" v-if="rowData.has_rules">HAS RULES</b-badge>
        <b-badge variant="info" v-else>NO RULES</b-badge>
        <form>
          <b-form-group class="text-left" label="Name">
            <b-form-input required v-model="form.name" type="text">
            </b-form-input>
            <span v-if="error.name" class="small text-danger">{{
              error.name
            }}</span>
          </b-form-group>
          <b-form-group class="text-left" label="IPs">
            <FieldAdder
              placeholder="127.0.0.1"
              v-for="(ip, idx) in ips"
              :key="idx"
              :last="ips.length - 1 === idx"
              v-model="ips[idx]"
              @remove="ips.splice(idx, 1)"
            />
            <div class="action">
              <b-button block variant="primary" @click="ips.push('')">
                <i class="text-light fa fa-plus" />
              </b-button>
            </div>
            <span v-if="error.ips" class="small text-danger">{{
              error.ips
            }}</span>
          </b-form-group>

          <b-form-group class="text-left" label="Prefix">
            <b-form-input v-model="form.prefix" type="text"> </b-form-input>
            <span v-if="error.prefix" class="small text-danger">{{
              error.prefix
            }}</span>
          </b-form-group>
          <div class="row">
            <b-form-group class="text-left col-6" label="SIP Server">
              <b-form-input v-model="form.sip_server" type="text">
              </b-form-input>
              <span v-if="error.sip_server" class="small text-danger">{{
                error.sip_server
              }}</span>
            </b-form-group>
            <b-form-group class="text-left col-6" label="SIP Server Port">
              <b-form-input v-model="form.sip_server_port" type="text">
              </b-form-input>
              <span v-if="error.sip_server_port" class="small text-danger">{{
                error.sip_server_port
              }}</span>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="text-left col-6" label="SIP Server Transport">
              <b-form-input v-model="form.sip_server_transport" type="text">
              </b-form-input>
              <span
                v-if="error.sip_server_transport"
                class="small text-danger"
                >{{ error.sip_server_transport }}</span
              >
            </b-form-group>
            <b-form-group class="text-left col-6" label="RTP Proxy">
              <b-form-input v-model="form.rtp_proxy" type="text">
              </b-form-input>
              <span v-if="error.rtp_proxy" class="small text-danger">{{
                error.rtp_proxy
              }}</span>
            </b-form-group>
          </div>
          <b-form-group class="text-left" label="Offer Codecs">
            <b-form-input v-model="form.offer_codecs" type="text">
            </b-form-input>
            <span v-if="error.offer_codecs" class="small text-danger">{{
              error.offer_codecs
            }}</span>
          </b-form-group>
          <div class="text-center">
            <button
              @click.prevent="editIP"
              class="btn btn-primary font-weight-bold"
            >
              Edit
            </button>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>
<script>
import http from "@/axios";
import FieldAdder from "@/components/FieldAdder.vue";

export default {
  components: { FieldAdder },
  name: "rule_ip",
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editLoading: false,
      ips: [""],
      form: {},
      fullPage: false,
      error: {},
    };
  },
  computed: {
    rawIps() {
      return this.rowData.ips
        .map((ipData) => ipData.ip)
        .filter((ip) => ip !== "")
        .join(", ");
    },
  },
  methods: {
    async openEditIPModal() {
      this.editLoading = true;
      this.$modal.show(`editIPModal${this.rowData.id}`);
      await http
        .get(`/sbc/ips/show/${this.rowData.id}`)
        .then((res) => {
          this.ips = res.data.data.ips.length
            ? res.data.data.ips.map(({ ip }) => ip)
            : [""];
          this.form = res.data.data;
          this.editLoading = false;
        })
        .catch((e) => {
          console.log(e.response);
          this.editLoading = false;
          this.$notify({
            group: "rules",
            title: e.response.data.message,
            type: "error",
          });
        });
    },
    async editIP() {
      this.editLoading = true;
      await http
        .put(`/sbc/ips/${this.rowData.id}`, {
          ...this.form,
          ips: this.ips.filter((ip) => ip !== ""),
        })
        .then((result) => {
          this.editLoading = false;
          this.$modal.hide("editIPModal" + this.rowData.id);
          this.$notify({
            group: "rules",
            title: result.data.message,
            type: "success",
          });
          this.$parent.$attrs.reload();
        })
        .catch((err) => {
          this.editLoading = false;
          this.$notify({
            group: "rules",
            title: err.response.data.message,
            type: "error",
          });
          this.error = err.response.data.error;
        });
    },
    clearData() {
      this.form = {};
      this.error = {};
    },
  },
};
</script>
